import type { FC } from 'react';
import cx from 'classnames';

import type { ChatItem } from 'Features/AiCompanion/services';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

import styles from './UserItem.module.scss';

interface UserItemProps {
	item: ChatItem;
}

export const UserItem: FC<UserItemProps> = ({ item }) => {
	const isAiCompanionMultiConversationEnabled = useFeatureToggle(FEATURES.enableAiCompanionMultiConversation);

	return (
		<div className={cx(styles.content, isAiCompanionMultiConversationEnabled && styles.multiConversation)}>
			{item.content}
		</div>
	);
};
